<h5 class="filter-title">{{ labels.TITLE }}</h5>
<div class="options-container">
    <div class="filter-option">
        <label for="tissueSite">{{ labels.TUMOR_SITE }}</label>
        <ngx-select-dropdown class="control-input-ngx" [config]="selectionConfig" [multiple]="true"
            [options]="possibleSites" [(ngModel)]="selectedTissueSites"
            (change)="handleTissueSiteChanged()"></ngx-select-dropdown>
    </div>
    <div class="filter-option">
        <label for="primarySite">{{ labels.PRIMARY_SITE }}</label>
        <ngx-select-dropdown class="control-input-ngx" [config]="selectionConfig" [multiple]="true"
            [options]="possibleSites" [(ngModel)]="selectedPrimarySites"
            (change)="updateFilterData()"></ngx-select-dropdown>
    </div>
    <div class="filter-option">
        <label for="tumorSubtype">{{ labels.TUMOR_SUBTYPE }}</label>
        <ngx-select-dropdown class="control-input-ngx" [config]="selectionConfig" [multiple]="true"
            [options]="possibleSubtypes" [(ngModel)]="selectedSubtypes"
            (change)="updateFilterData()"></ngx-select-dropdown>
    </div>
</div>